<template>
    <div ref="chartContainer" style="position: relative;">
        <div class="tooltip" ref="tooltip"
            style="visibility: hidden; position: absolute; background-color: #fff; border: 1px solid #ccc; padding: 4px; border-radius: 4px;">
        </div>
        <div ref="chart"></div>
    </div>
</template>

<script>
import * as d3 from 'd3'

export default {
    name: 'LineGraph',
    props: {
        data: {
            type: Array,
            required: true
        },
        dataName: {
            type: String,
            required: true
        },
        width: {
            type: Number,
            default: 600
        },
        height: {
            type: Number,
            default: 300
        }
    },
    data() {
        return {
            margin: { top: 20, right: 20, bottom: 30, left: 50 },
        }
    },
    watch: {
        data() {
            this.drawChart()
        }
    },
    mounted() {
        this.drawChart()
    },
    methods: {
        drawChart() {
            d3.select(this.$refs.chart).selectAll('*').remove();

            if (!this.data || this.data.length === 0) return;

            const parsedData = this.data
                .map(d => ({ date: new Date(d.date), count: d.count }))
                .sort((a, b) => a.date - b.date);

            const svg = d3.select(this.$refs.chart)
                .append('svg')
                .attr('viewBox', `0 0 600 300`)
                .attr('preserveAspectRatio', 'xMidYMid meet')
                .style('width', '100%')
                .style('height', '300');

            const margin = this.margin;
            const width = this.width - margin.left - margin.right;
            const height = this.height - margin.top - margin.bottom;

            const g = svg.append('g')
                .attr('transform', `translate(${margin.left}, ${margin.top})`);

            // X scale
            const x = d3.scaleTime()
                .domain(d3.extent(parsedData, d => d.date))
                .range([0, width]);

            // Y scale
            const y = d3.scaleLinear()
                .domain(d3.extent(parsedData, d => d.count))
                .nice()
                .range([height, 0]);

            // X Axis
            g.append('g')
                .attr('transform', `translate(0, ${height})`)
                .call(d3.axisBottom(x));

            // Y Axis
            g.append('g').call(d3.axisLeft(y));

            // Line generator
            const line = d3.line()
                .x(d => x(d.date))
                .y(d => y(d.count));

            // Draw line
            g.append('path')
                .datum(parsedData)
                .attr('fill', 'none')
                .attr('stroke', '#2962FF')
                .attr('stroke-width', 2)
                .attr('d', line);

            const tooltip = d3.select(this.$refs.tooltip);

            g.selectAll('circle')
                .data(parsedData)
                .enter()
                .append('circle')
                .attr('cx', d => x(d.date))
                .attr('cy', d => y(d.count))
                .attr('r', 4)
                .attr('fill', '#2962FF')
                .on('mouseover', (event, d) => {
                    tooltip
                        .style('visibility', 'visible')
                        .text(`Count: ${d.count}`);
                })
                .on('mousemove', (event) => {
                    const [mouseX, mouseY] = d3.pointer(event, this.$refs.chartContainer);

                    tooltip
                        .style('top', mouseY + 'px')
                        .style('left', mouseX + 'px');
                })
                .on('mouseout', () => {
                    tooltip.style('visibility', 'hidden');
                });
        }
    }
}
</script>

<style scoped>
.tooltip {
  position: absolute;
  visibility: hidden;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 4px;
  border-radius: 4px;
  pointer-events: none;
}
</style>